<template>
  <div v-cloak id="app" v-loading="!inited">
    <router-view v-if="inited" />
  </div>
</template>

<script>
/* eslint-disable */
import {mapActions, mapGetters, mapMutations} from 'vuex'
import * as qm from 'src/utils/utils'
/* eslint-enable */

export default {
  name: 'App',
  data() {
    return {
      // intercomInited: false,
      inited: false,
    }
  },
  computed: {
    ...mapGetters({
      accountInfo: 'accountInfo',
    }),
  },
  watch: {
    $route() {
      if (this.inited) {
        this.init()
      }
    },
  },
  async created() {
    await this.setAccountInfo('app.created')
    const systemInfo = {
      innerHeight: window.innerHeight,
    }
    await this.setSystemInfo(systemInfo)
    this.$nextTick(async () => {
      await this.init()
      setTimeout(() => {
        this.inited = true
      }, 200)
    })
  },
  methods: {
    navigateToLoginPage() {
      const isLoginPath = window.location.pathname === '/login'
      if (!isLoginPath) {
        const returnUrl = encodeURIComponent(window.location.href)
        window.location = `/login?returnUrl=${returnUrl}&type=2`
        // this.$router.replace()
      }
    },
    navigateToMainIndex() {
      qm.log(
        'navigateToMainIndex\n window.location.path :\n',
        window.location.path,
      )
      if (
        !['/content/transfer', '/content/login', '/quiz/transfer'].includes(
          window.location.pathname,
        )
      ) {
        this.$router.replace(`/index`)
      }
    },

    async init() {
      // 查询登录
      if (!this.accountInfo.isLogin) {
        await this.checkLogin()
        return
      }
      // 查询绑定
      if (!this.accountInfo.isBoundWechat) {
        await this.checkOpenId()
        return
      }
      // 对讲机
      // if (!this.intercomInited) {
      //   this.initIntercom()
      // }
    },
    // initIntercom() {
    //   try {
    //     // For Intercom
    //     const APP_ID = 't80j35ze'
    //     window.Intercom('boot', {
    //       app_id: APP_ID,
    //     })
    //     const user = this.accountInfo
    //     window.Intercom('boot', {
    //       app_id: APP_ID,
    //       user_id: user.uid.toString(),
    //       name: user.name,
    //       phone: user.phone,
    //     })
    //     this.intercomInited = true
    //   } catch (e) {
    //     qm.log('initIntercom error:', e)
    //     this.$message.error(e.message)
    //   } finally {
    //   }
    // },
    // 检查项目
    async checkLogin() {
      // qm.log('checkLogin app')
      await this.setAccountInfo()
      if (this.accountInfo.isLogin) {
        this.init()
      } else {
        this.navigateToLoginPage()
      }
    },
    async checkOpenId() {
      await this.setAccountInfo()
      if (this.accountInfo.isBoundWechat) {
        this.init()
      } else {
        this.navigateToLoginPage()
      }
    },

    ...mapActions({
      setAccountInfo: 'setAccountInfo',
    }),
    ...mapMutations({
      setSystemInfo: 'SET_SYSTEM_INFO',
    }),
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
}
</style>
